module.exports = __webpack_public_path__ + "img/service2-1.1f96724a.jpg";